import React from 'react';
import PropTypes from 'prop-types';

import {
  useTheme,
  SPOTAHOME_THEME,
  ERASMUSU_THEME,
  LANDLORD_THEME,
  PARTNER_DEMO_THEME,
  PARTNER_RUFA_THEME
} from '../ThemeProvider';

import ErasmusuLogo from './logos/erasmusu';
import SpotahomeLogo from './logos/spotahome';
import PartnerDemoLogo from './logos/partner_demo';
import PartnerRufaLogo from './logos/partners/rufa';

const LOGOS = {
  [SPOTAHOME_THEME]: SpotahomeLogo,
  [LANDLORD_THEME]: SpotahomeLogo,
  [ERASMUSU_THEME]: ErasmusuLogo,
  [PARTNER_DEMO_THEME]: PartnerDemoLogo,
  [PARTNER_RUFA_THEME]: PartnerRufaLogo
};

const Logo = props => {
  const { theme } = useTheme();

  const LogoComponent = LOGOS[theme];

  return <LogoComponent {...props} />;
};

Logo.propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOf(['small', 'normal', 'large']),
  theme: PropTypes.oneOf(['dark', 'light'])
};

Logo.defaultProps = {
  className: '',
  size: 'normal',
  theme: 'dark'
};

export default Logo;
